import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import isNaN from 'lodash/isNaN';

import { TextInput, InputRenderer, RenderConfig } from 'commons-ui';

const validationSchema = yup.object().shape({
	transactionId: yup.number().test({
		message: 'Invalid Transaction Id ',
		test: (value: any) => !isNaN(value)
	})
});

const filterDefaults = {
	transactionId: null
};

const renderConfig = new RenderConfig().setName('transactionId').setRenderer(TextInput).setRenderProps({
	placeholder: 'Transaction Id',
	noWrapper: true,
	size: 'compact'
});

interface TextInputFilterProps {
	onSubmit: (data: any) => void;
}

const TextInputFilter = ({ onSubmit }: TextInputFilterProps) => {
	const {
		watch,
		control,
		handleSubmit,
		formState: { errors }
	} = useForm({
		defaultValues: filterDefaults,
		resolver: yupResolver(validationSchema || yup.object())
	});

	const [css] = useStyletron();

	return (
		<form className={css({ display: 'flex', gap: '30px' })} onSubmit={handleSubmit(onSubmit)}>
			<div className={css({ width: '250px' })}>
				<InputRenderer errors={errors} field={renderConfig} control={control} watch={watch} />
			</div>
			<Button kind='primary' size='compact'>
				Apply TransactionId Filter
			</Button>
		</form>
	);
};

export default TextInputFilter;
